/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

import type { WorkGeoLocationPolygonDTO } from './WorkGeoLocationPolygonDTO';
import {
    WorkGeoLocationPolygonDTOFromJSON,
    WorkGeoLocationPolygonDTOFromJSONTyped,
    WorkGeoLocationPolygonDTOToJSON,
    WorkGeoLocationPolygonDTOToJSONTyped,
} from './WorkGeoLocationPolygonDTO';

/**
 * 
 * @export
 * @interface WorkGeoLocationDTO
 */
export interface WorkGeoLocationDTO  {
    /**
     * 
     * @type {number}
     * @memberof WorkGeoLocationDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof WorkGeoLocationDTO
     */
    place?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkGeoLocationDTO
     */
    pointLongitude?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkGeoLocationDTO
     */
    pointLatitude?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkGeoLocationDTO
     */
    boxWestBoundLongitude?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkGeoLocationDTO
     */
    boxEastBoundLongitude?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkGeoLocationDTO
     */
    boxSouthBoundLatitude?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkGeoLocationDTO
     */
    boxNorthBoundLatitude?: string;
    /**
     * 
     * @type {WorkGeoLocationPolygonDTO}
     * @memberof WorkGeoLocationDTO
     */
    workGeoLocationPolygon?: WorkGeoLocationPolygonDTO;
}

/**
 * Check if a given object implements the WorkGeoLocationDTO interface.
 */
export function instanceOfWorkGeoLocationDTO(value: object): value is WorkGeoLocationDTO {
    return true;
}

export function WorkGeoLocationDTOFromJSON(json: any): WorkGeoLocationDTO {
    return WorkGeoLocationDTOFromJSONTyped(json, false);
}

export function WorkGeoLocationDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkGeoLocationDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                  'place': json['place'] == null ? undefined : json['place'],
                  'pointLongitude': json['pointLongitude'] == null ? undefined : json['pointLongitude'],
                  'pointLatitude': json['pointLatitude'] == null ? undefined : json['pointLatitude'],
                  'boxWestBoundLongitude': json['boxWestBoundLongitude'] == null ? undefined : json['boxWestBoundLongitude'],
                  'boxEastBoundLongitude': json['boxEastBoundLongitude'] == null ? undefined : json['boxEastBoundLongitude'],
                  'boxSouthBoundLatitude': json['boxSouthBoundLatitude'] == null ? undefined : json['boxSouthBoundLatitude'],
                  'boxNorthBoundLatitude': json['boxNorthBoundLatitude'] == null ? undefined : json['boxNorthBoundLatitude'],
                  'workGeoLocationPolygon': json['workGeoLocationPolygon'] == null ? undefined : WorkGeoLocationPolygonDTOFromJSON(json['workGeoLocationPolygon']),
    };
}

export function WorkGeoLocationDTOToJSON(json: any): WorkGeoLocationDTO {
    return WorkGeoLocationDTOToJSONTyped(json, false);
}

export function WorkGeoLocationDTOToJSONTyped(value?: WorkGeoLocationDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'place': value['place'],
        'pointLongitude': value['pointLongitude'],
        'pointLatitude': value['pointLatitude'],
        'boxWestBoundLongitude': value['boxWestBoundLongitude'],
        'boxEastBoundLongitude': value['boxEastBoundLongitude'],
        'boxSouthBoundLatitude': value['boxSouthBoundLatitude'],
        'boxNorthBoundLatitude': value['boxNorthBoundLatitude'],
        'workGeoLocationPolygon': WorkGeoLocationPolygonDTOToJSON(value['workGeoLocationPolygon']),
    };
}


